import "./facets";
import "./filter-drawer";

document.addEventListener("DOMContentLoaded", () => {
  const grid = document.getElementById("ProductGridContainer");
  const sentinel = document.getElementById("product-grid-sentinel");
  const sectionId = grid?.dataset.sectionId;

  if (!grid || !sentinel || !sectionId) return;

  let currentPage = 1;
  let loading = false;

  const observer = new IntersectionObserver(loadMore, {
    rootMargin: "300px",
  });
  observer.observe(sentinel);

  async function loadMore(entries) {
    if (!entries[0].isIntersecting || loading) return;

    loading = true;
    observer.unobserve(sentinel);

    try {
      const baseUrl = window.location.pathname + window.location.search;
      const url = new URL(window.location.origin + baseUrl);
      currentPage += 1;
      url.searchParams.set("page", currentPage);
      url.searchParams.set("section_id", sectionId);

      const html = await fetch(url).then((res) => res.text());
      const doc = new DOMParser().parseFromString(html, "text/html");

      doc
        .querySelectorAll("#ProductGridContainer > *")
        .forEach((node) => grid.appendChild(node));

      const hasMore = doc.querySelector('.pagination [rel="next"]');
      if (hasMore) {
        observer.observe(sentinel);
      } else {
        sentinel.remove();
      }
    } catch (err) {
      console.error("Infinite scroll error:", err);
      observer.observe(sentinel);
    } finally {
      loading = false;
    }
  }
});
